import { collection, doc } from "firebase/firestore";

const assertSegments = (segments) => {
  if (!Array.isArray(segments) || segments.some((s) => typeof s !== "string" || !s)) {
    throw new Error(`Invalid Firestore path segments: ${JSON.stringify(segments)}`);
  }
};

export const safeCollection = (db, ...segments) => {
  assertSegments(segments);
  // collection path must have odd number of segments
  if (segments.length % 2 === 0) {
    throw new Error(`Invalid collection path (even segments): ${segments.join("/")}`);
  }
  return collection(db, ...segments);
};

export const safeDoc = (db, ...segments) => {
  assertSegments(segments);
  // doc path must have even number of segments
  if (segments.length % 2 !== 0) {
    throw new Error(`Invalid document path (odd segments): ${segments.join("/")}`);
  }
  return doc(db, ...segments);
};
